export default __webpack_public_path__ + "static/media/FECHAS_07.6e6daddd.png";